export const validateEmail = (value: string) => {
  const regex = new RegExp('^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}$');
  return value && regex.test(value);
};

export const validateProto = (val: string) => {
  const regexp = new RegExp('^(?:[a-z]+:)?//', 'i');

  if (val) {
    return regexp.test(val);
  }

  return true;
};

// add proto on the fly
export const addProto = (value: string, proto = 'https://') => {
  return validateProto(value) ? value : proto + value;
};

export const validateUrl = (value: string, withProto: boolean = true, specialChars = false) => {
  // eslint-disable-next-line no-param-reassign
  value = value.trim().toLowerCase();

  // skip spaces
  if (value.includes(' ')) {
    return false;
  }

  // skip emoji
  // https://stackoverflow.com/questions/18862256/how-to-detect-emoji-using-javascript
  if (/[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u.test(value)) {
    return false;
  }

  // skip currencies
  const curr =
    /[$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/;
  if (curr.test(value)) {
    return false;
  }

  if (withProto || specialChars) {
    if (specialChars && !validateProto(value)) {
      // add proto on the fly
      // eslint-disable-next-line no-param-reassign
      value = `https://${value}`;
    }
    return /^(?:(?:(?:https?|http):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,200})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,10})?(?:[/?#]\S*)?$/i.test(
      value
    );
  }

  return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi.test(
    value
  );
};
